<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Services</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" v-if="hasPermission('service create')"
              :to="{ name: 'create-service' }">create</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <div v-if="services.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(service, index) in filteredServices" :key="index">
                  <th scope="row">{{ service.id }}</th>
                  <td>{{ service.name_ar }}</td>
                  <td>{{ service.name_en }}</td>
                  <td>
                    <img :src="`${service.image}`" width="50" height="50" class="img-thumbnail" />
                  </td>
                  <!-- <td><img :src="`${assets}service.image`"></td> -->

                  <td>
                    <!-- <button class="me-2 btn btn-danger" v-if="hasPermission('service delete')"
                      @click="deleteService(service.id)">
                      Delete
                    </button> -->
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('service update')"
                      :to="{ name: 'edit-service', params: { id: service.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Services found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
import { store } from '@/Store';
export default {
  name: "AllServices",
  components: {
    MyTable,
    // Paginate,
  },

  data() {
    return {
      dataTable: [],
      services: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        { label: 'Image', key: 'image' },
      ],
    };
  },

  async created() {
    this.fetchServices();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredServices() {
      if (!this.searchTerm) {
        return this.services;
      }
      const term = this.searchTerm.toLowerCase();
      return this.services.filter(
        (service) =>
          service.name.toLowerCase().includes(term) ||
          service.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch services
    async fetchServices() {
      try {
        const response = await axios.get(
          `/admin/admin/service/all`
        );
        this.services = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteService(id) {
      console.log("delete service id: ", id);
      axios
        .delete(`/admin/admin/service/delete/${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchServices();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};


</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>